module.exports = __webpack_public_path__ + "static/media/school.061ed820.webp";